<style lang="less">
.selectpop {
  margin: 0;
  .selpop {
    display: inline-block;
    .box {
      position: relative;
      background: #f6f6f6;
      height: 27px;
      border-radius: 4px;
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 12px;
      color: #3d434d;
      padding: 0 7px;
      span {
        margin-left: 10px;
        width: 6px;
        height: 6px;
        position: relative;
        &::after {
          content: "";
          display: block;
          position: absolute;
          width: 0;
          height: 0;
          left: 0;
          border: 3px solid #eee;
          border-top: 4px solid #c4c4c4;
          border-bottom: 0px;
          top: 50%;
          margin-top: -2px;
          left: 50%;
          margin-left: -3px;
        }
      }
    }
  }

  .open {
    background: #ebf6ff;
    label {
      color: #2284f6;
    }
    span {
      transform: rotate(-180deg);
      &::after {
        border-top-color: #2284f6 !important;
      }
    }
  }
}
</style>
<template>
  <div class="selectpop">
    <div class="selpop" :class="{open: active}">
      <div class="box">
        <label>{{ text }}</label>
        <span></span>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    text: {
      type: String,
      default: "",
    },
    active: {
      type: Boolean,
      default: false,
    },
    val: {
      type: String,
      default: "",
    },
  },
  data() {
    return {};
  },
  methods: {},
};
</script>